import {useState, useEffect} from 'external/react'
import {mapValues, mapKeys, diff} from 'external/lodash'
import update from 'external/immutability-helper'

export default function useForm(initialState) {
  const touchedState = mapKeys(mapValues(initialState, () => false), (name,key) => `${key}_touched`)
  const [state, setState] = useState({...initialState, ...touchedState})
  function handleChange (name, value = e => e.target.value) {
    return event => {
      const newState = {...state, [name]: value(event), [`${name}_touched`]: true} 
      setState(newState)
    }
  }
  function resetState (overrideState={}) {    
    setState({...initialState, ...touchedState, ...overrideState})   
  }
  function createHandler(mapper) {
    return event => {
      const newState = Object.entries(mapper(event)).reduce((newState, [name, value])=>{
        newState[name] = value
        newState[`${name}_touched`] = true
        return newState
      }, {})
      setState({...state, ...newState})
    }
  }
  function updateState (...commands) {
      const newState = commands.reduce((state, command) => update(state, command), state)
      setState(newState)
  }
  function hasStateChanged () {
    return diff(state, initialState).length > 0;
  }
  return {state, setState, handleChange, resetState, createHandler, updateState, hasStateChanged}
}
